<template>
  <div class="container">

    <h1>{{account_receivables_detail.customer_display_name}} {{account_receivables_detail.agent_name}}</h1>
    {{account_receivables_detail.company_address.address}},
    {{account_receivables_detail.company_address.city}},
    {{account_receivables_detail.company_address.state}}
    {{account_receivables_detail.company_address.zipcode}} -
    ID: {{account_receivables_detail.company_address.customer_id}} -
    {{account_receivables_detail.company_address.license_number}}

    <br>

    <table class="table table-striped table-bordered table-hover table-condensed">
      <thead>
      <th>Contact</th>
      <th>Phone#</th>
      <th>Email</th>
      <th>Region</th>
      </thead>

      <tr>
        <td width = "200"><input
            type="text"
            id="ar_contact"
            class="form-control"
            :value="account_receivables_detail.customer_data.ar_contact"
            @input="account_receivables_detail.customer_data.ar_contact = $event.target.value"
            @blur="set_customer_field_ar (account_receivables_detail.customer_data.customer_id,'ar_contact',account_receivables_detail.customer_data.ar_contact)">
        </td>
        <td width = "200"><input
            type="text"
            id="ar_phone"
            class="form-control"
            :value="account_receivables_detail.customer_data.ar_phone"
            @input="account_receivables_detail.customer_data.ar_phone = $event.target.value"
            @blur="set_customer_field_ar (account_receivables_detail.customer_data.customer_id,'ar_phone',account_receivables_detail.customer_data.ar_phone)">
        </td>
        <td width = "200"><input
            type="text"
            id="ar_email"
            class="form-control"
            :value="account_receivables_detail.customer_data.ar_email"
            @input="account_receivables_detail.customer_data.ar_email = $event.target.value"
            @blur="set_customer_field_ar (account_receivables_detail.customer_data.customer_id,'ar_email',account_receivables_detail.customer_data.ar_email)">
        </td>
        <td width = "200"><input
            type="text"
            id="ar_region"
            class="form-control"
            :value="account_receivables_detail.customer_data.ar_region"
            @input="account_receivables_detail.customer_data.ar_region = $event.target.value"
            @blur="set_customer_field_ar (account_receivables_detail.customer_data.customer_id,'ar_region',account_receivables_detail.customer_data.ar_region)">
        </td>
      </tr>

      <tr>
        <td width = "200"><input
            type="text"
            id="ar_contact_2"
            class="form-control"
            :value="account_receivables_detail.customer_data.ar_contact_2"
            @input="account_receivables_detail.customer_data.ar_contact_2 = $event.target.value"
            @blur="set_customer_field_ar (account_receivables_detail.customer_data.customer_id,'ar_contact_2',account_receivables_detail.customer_data.ar_contact_2)">
        </td>
        <td width = "200"><input
            type="text"
            id="ar_phone_2"
            class="form-control"
            :value="account_receivables_detail.customer_data.ar_phone_2"
            @input="account_receivables_detail.customer_data.ar_phone_2 = $event.target.value"
            @blur="set_customer_field_ar (account_receivables_detail.customer_data.customer_id,'ar_phone_2',account_receivables_detail.customer_data.ar_phone_2)">
        </td>
        <td width = "200"><input
            type="text"
            id="ar_email_2"
            class="form-control"
            :value="account_receivables_detail.customer_data.ar_email_2"
            @input="account_receivables_detail.customer_data.ar_email_2 = $event.target.value"
            @blur="set_customer_field_ar (account_receivables_detail.customer_data.customer_id,'ar_email_2',account_receivables_detail.customer_data.ar_email_2)">
        </td>

        <td>

        </td>

      </tr>



      <tr>
        <td width = "200">
          Sales Rep
          <input
              type="text"
              id="ar_sales_rep"
              class="form-control"
              :value="account_receivables_detail.customer_data.ar_sales_rep"
              @input="account_receivables_detail.customer_data.ar_sales_rep = $event.target.value"
              @blur="set_customer_field_ar (account_receivables_detail.customer_data.customer_id,'ar_sales_rep',account_receivables_detail.customer_data.ar_sales_rep)">
        </td>

        <td v-if="account_receivables_detail.customer_data.ar_bad_account === 1" width="200">
          Bad Account<br>
          <button class="yes_button" v-on:click="set_customer_field_ar(account_receivables_detail.customer_data.customer_id,'ar_bad_account',0)">YES</button></td>
        <td v-else>
          Bad Account<br>
          <button class="no_button" v-on:click="set_customer_field_ar(account_receivables_detail.customer_data.customer_id,'ar_bad_account',1)">NO</button></td>



        <td v-if="account_receivables_detail.customer_data.ar_contacted === 1" width="200">
          Contacted<br>
          <button class="yes_button" v-on:click="set_customer_field_ar(account_receivables_detail.customer_data.customer_id,'ar_contacted',0)">YES</button></td>
        <td v-else>
          Contacted<br>
          <button class="no_button" v-on:click="set_customer_field_ar(account_receivables_detail.customer_data.customer_id,'ar_contacted',1)">NO</button></td>


        <td v-if="account_receivables_detail.customer_data.ar_scheduled === 1" width="200">
          Scheduled<br>
          <button class="yes_button" v-on:click="set_customer_field_ar(account_receivables_detail.customer_data.customer_id,'ar_scheduled',0)">YES</button></td>
        <td v-else>
          Scheduled<br>
          <button class="no_button" v-on:click="set_customer_field_ar(account_receivables_detail.customer_data.customer_id,'ar_scheduled',1)">NO</button></td>



      </tr>


    </table>

    <template v-if="account_receivables_detail.details.length > 0">

      <div class="row">
        <div class="col-2"></div>
        <div class="col-2 rounded-border-gray">
          <span class="total">TOTAL INVOICES</span><br>
          <span class="quantity">{{account_receivables_detail.all_invoices}}</span>
        </div>
        <div class="col-1"></div>
        <div class="col-2 rounded-border-gray">
          <span class="total">TOTAL PAID</span><br>
          <span class="quantity">{{account_receivables_detail.all_paid_invoices}}</span>
        </div>
        <div class="col-1"></div>
        <div class="col-2 rounded-border-gray">
          <span class="total">TOTAL UNPAID</span><br>
          <span class="quantity text-color-red">{{account_receivables_detail.total_invoices}}</span>
        </div>
      </div>

      <div style="text-align:center;margin:12px 0;">
        <button
            type="button"
            class="yes_button"
            v-bind:class="{ 'copy-moved': copyKindDone === 'short' }"
            v-on:click="copyArTable('short')"
        >{{ copyKindDone === 'short' ? 'Copied' : 'Copy short version' }}</button>
        &nbsp;
        <button
            type="button"
            class="yes_button"
            v-bind:class="{ 'copy-moved': copyKindDone === 'regular' }"
            v-on:click="copyArTable('regular')"
        >{{ copyKindDone === 'regular' ? 'Copied' : 'Copy regular version' }}</button>
        <div v-if="copyKindDone" class="copy-alert">Copied</div>
      </div>

      <table class="table table-striped table-bordered table-hover table-condensed">
        <thead>
        <tr>
          <th>#</th>
          <th>Invoice</th>
          <th>Order Total</th>
          <th>Ship Date</th>
          <th>Payment Balance</th>
          <th>Due Date</th>
          <th>Days Past Due</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="invoice_detail in account_receivables_detail.details" v-bind:key="invoice_detail.id">
          <td>{{invoice_detail.position}}</td>
          <td>{{invoice_detail.order_short_id}}</td>
          <td>$ {{invoice_detail.total_amount_formatted}}</td>

          <td>{{invoice_detail.ship_date_format_usa}}</td>

          <td>$ {{invoice_detail.payment_balance_formatted}}</td>
          <td>{{invoice_detail.payment_due_date_format_usa}}</td>
          <td>{{invoice_detail.days_past_due}}</td>
        </tr>

        <tr>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td class="redbold">TOTAL DUE &nbsp; {{account_receivables_detail.total_due}}</td>
          <td></td>
          <td></td>
        </tr>

        </tbody>
      </table>

    </template>

    <div class="form-group">
      <input type="text" id="note" class="form-control" v-model="customerData.new_note">
      <button @click="store_note_in_database()">Add Note</button>
    </div>

    <br>
    <table v-if="account_receivables_detail.notes" class="table table-striped table-bordered table-hover table-condensed">
      <thead>
      </thead>
      <tbody>
      <tr v-for="notes in account_receivables_detail.notes" v-bind:key="notes.id">
        <td width="200">{{notes.date}}</td>
        <td align="LEFT">{{notes.note}}</td>
      </tr>
      </tbody>
    </table>
    <br>
    <br>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      customerData: {
        new_note: '',
      },
      copyKindDone: '',
      copyResetTimer: null,
    }
  },
  computed: {
    ...mapGetters({
      account_receivables_detail: 'admin/account_receivables_detail',
    }),
  },
  props: {
    customer_id: null,
  },
  mounted() {
    this.CustomerARDetail();
  },
  destroyed() {
    this.$store.dispatch('admin/getAccountReceivablesList', {'customer_id': 999999});
  },
  methods: {
    CustomerARDetail () {
      this.$store.dispatch('admin/getAccountReceivablesList', {'customer_id': this.customer_id});
    },
    set_customer_field_ar (customer_id,fieldname,value) {
      this.$store.dispatch('admin/setCustomerFieldAR' , {customer_id,fieldname,value})
    },
    store_note_in_database() {
      this.$store.dispatch('admin/addNewCustomerNoteAR', {'customer_id': this.customer_id, 'note': "[AR] " + this.customerData.new_note});
      this.customerData.new_note = "";
    },
    markCopied: function (kind) {
      var self = this;
      this.copyKindDone = '';
      this.$nextTick(function () {
        self.copyKindDone = kind;
      });
      if (this.copyResetTimer) {
        clearTimeout(this.copyResetTimer);
      }
      this.copyResetTimer = setTimeout(function () {
        self.copyKindDone = '';
        self.copyResetTimer = null;
      }, 1500);
    },
    copyArTable: function (kind) {
      var details = (this.account_receivables_detail && this.account_receivables_detail.details) ? this.account_receivables_detail.details : [];
      var total = this.account_receivables_detail ? this.account_receivables_detail.total_due : '';
      var isRegular = (kind === 'regular');

      function cell(v) {
        if (v === null || v === undefined) return '';
        return String(v)
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;');
      }

      var body = '';
      var plain = isRegular
          ? 'Invoice\tOrder Total\tShip Date\tDue Date\tDays\tBalance\n'
          : 'Invoice\tDue Date\tDays\tBalance\n';

      for (var i = 0; i < details.length; i++) {
        var d = details[i];
        var inv = cell(d.order_short_id);
        var orderTotal = '$ ' + cell(d.total_amount_formatted);
        var ship = cell(d.ship_date_format_usa);
        var due = cell(d.payment_due_date_format_usa);
        var days = cell(d.days_past_due);
        var bal = '$ ' + cell(d.payment_balance_formatted);

        if (isRegular) {
          body += '<tr>' +
              '<td>' + inv + '</td>' +
              '<td style="text-align:right">' + orderTotal + '</td>' +
              '<td>' + ship + '</td>' +
              '<td>' + due + '</td>' +
              '<td style="text-align:right">' + days + '</td>' +
              '<td style="text-align:right">' + bal + '</td>' +
              '</tr>';
          plain += inv + '\t' + orderTotal + '\t' + ship + '\t' + due + '\t' + days + '\t' + bal + '\n';
        } else {
          body += '<tr><td>' + inv + '</td><td>' + due + '</td><td style="text-align:right">' + days + '</td><td style="text-align:right">' + bal + '</td></tr>';
          plain += inv + '\t' + due + '\t' + days + '\t' + bal + '\n';
        }
      }

      var html;
      if (isRegular) {
        plain += '\t\t\t\tTotal Due\t' + total + '\n';
        html =
            '<table border="1" cellpadding="6" cellspacing="0" style="border-collapse:collapse;width:560px;font:13px Arial;border:1px solid #ddd">' +
            '<tr style="background:#f3f3f3;font-weight:bold">' +
            '<td>Invoice</td>' +
            '<td style="text-align:right">Order Total</td>' +
            '<td>Ship Date</td>' +
            '<td>Due Date</td>' +
            '<td style="text-align:right">Days</td>' +
            '<td style="text-align:right">Balance</td>' +
            '</tr>' +
            body +
            '<tr>' +
            '<td colspan="5" style="text-align:right">Total Due</td>' +
            '<td style="text-align:right"><b style="color:#c62828">' + cell(total) + '</b></td>' +
            '</tr>' +
            '</table>';
      } else {
        plain += '\t\tTotal Due\t' + total + '\n';
        html =
            '<table border="1" cellpadding="6" cellspacing="0" style="border-collapse:collapse;width:400px;font:13px Arial;border:1px solid #ddd">' +
            '<tr style="background:#f3f3f3;font-weight:bold">' +
            '<td>Invoice</td><td>Due Date</td><td style="text-align:right">Days</td><td style="text-align:right">Balance</td></tr>' +
            body +
            '<tr><td colspan="3" style="text-align:right">Total Due</td>' +
            '<td style="text-align:right"><b style="color:#c62828">' + cell(total) + '</b></td></tr>' +
            '</table>';
      }

      var self = this;
      if (navigator.clipboard && window.ClipboardItem) {
        var item = new ClipboardItem({
          'text/html': new Blob([html], { type: 'text/html' }),
          'text/plain': new Blob([plain], { type: 'text/plain' })
        });
        navigator.clipboard.write([item]).then(function () {
          self.markCopied(kind);
        }).catch(function () {
          self.fallbackCopyPlain_(plain, kind);
        });
      } else {
        this.fallbackCopyPlain_(plain, kind);
      }
    },
    fallbackCopyPlain_: function (plain, kind) {
      var ta = document.createElement('textarea');
      ta.value = plain;
      ta.setAttribute('readonly', '');
      ta.style.position = 'fixed';
      ta.style.left = '-9999px';
      document.body.appendChild(ta);
      ta.select();
      try {
        document.execCommand('copy');
        this.markCopied(kind);
      } catch (err) {
      }
      document.body.removeChild(ta);
    },
  }
}

</script>

<style>

div.rounded-border-gray
{
  padding: 5px;
  border-radius: 30px;
  border: 10px solid #999;
  -moz-border-radius: 15px;
}

.redbold {
  color:red;
  font-weight: bold;
}

.total {
  font-weight: bold;
  font-size: 18px;
}

.quantity {
  font-weight: bold;
  font-size: 60px;
}

.text-color-red {
  color:red;
}

.yes_button {
  color: white;
  background-color: green;
  padding-left: 10px;
  padding-right: 10px;
  padding-top: 3px;
  border-radius: 4px;
  border-style: hidden;
  /*font-size: smaller;*/
  font-weight: 700;
}
.no_button {
  color: white;
  background-color: red;
  padding-left: 10px;
  padding-right: 10px;
  padding-top: 3px;
  border-radius: 4px;
  border-style: hidden;
  /*font-size: smaller;*/
  font-weight: 700;
}
table.ar-simple {
  border-collapse: collapse;
  width: 400px;
  font: 13px Arial;
  border: 1px solid #ddd;
  margin: 20px auto;
}
table.ar-simple td {
  padding: 6px 10px;
  border-bottom: 1px solid #e6e6e6;
}
table.ar-simple tr:first-child td {
  background: #f3f3f3;
  font-weight: bold;
}
table.ar-simple td + td + td {
  text-align: right;
}
table.ar-simple b {
  color: #c62828;
}

.copy-moved {
  animation: copy-nudge 0.35s ease;
}

@keyframes copy-nudge {
  0%   { transform: translateY(0); }
  35%  { transform: translateY(-6px); }
  100% { transform: translateY(0); }
}

.copy-alert {
  margin-top: 6px;
  color: #2e7d32;
  font-weight: 700;
  font-size: 14px;
}

</style>
